import { spotsLabel } from "@/hooks/useSponsorConfig";

export const SpotsBadge = ({ remaining, dark = false, testId }) => {
  if (remaining === null || remaining === undefined) return null;
  const soldOut = remaining <= 0;
  const urgent = !soldOut && remaining <= 2;
  const cls = soldOut
    ? "bg-espresso/80 text-cream border-espresso"
    : urgent
      ? "bg-rust text-primary-foreground border-rust"
      : dark
        ? "bg-cream/10 text-cream border-cream/30"
        : "bg-rust/10 text-rust border-rust/40";
  return (
    <span data-testid={testId} className={`inline-flex items-center label-font text-[10px] tracking-[0.12em] px-2.5 py-1 border ${cls}`}>
      {spotsLabel(remaining)}
    </span>
  );
};
